import React from "react";
import { translate, getLanguage } from "react-switch-lang";

const EMAIL = "theresourcemap@gmail.com";
const EMAIL_LINK = `mailto:${EMAIL}`;

const RESOURCE_MAP_URL =
  "https://www.swd.gov.hk/en/index/site_district/page_inkindass/";
const TEMP_SHELTER_URL =
  "https://www.swd.gov.hk/storage/asset/section/177/tc/List_of_Temporary_Shelter_Hostel_Short-term_Hostel_TC_Nov_2023.pdf";
const ETHNIC_SUPPORT_URL =
  "https://www.had.gov.hk/rru/tc_chi/programmes/support_service_centres.htm";
const ETHNIC_SERVICES_URL =
  "https://www.hkcss.org.hk/%e5%b0%91%e6%95%b8%e6%97%8f%e8%a3%94%e6%9c%8d%e5%8b%99%e5%90%8d%e5%96%ae/";
const SERVICE_MAP_SOURCE_URL =
  "https://www.swd.gov.hk/en/svcdesk/download/listofserv/";

const resourceSourcesEn = [
  {
    label:
      "In-kind Assistance for Needy provided by the Social Welfare Department (as of August 2024)",
    href: RESOURCE_MAP_URL,
  },
  {
    label:
      "List of Temporary Shelter / Dormitory / Short-Term Accommodation provided by the Social Welfare Department (as of November 2023)",
    href: TEMP_SHELTER_URL,
  },
  {
    label:
      "List of Support Service Centres for Ethnic Minorities provided by the Ethnic Relations Division of the Home Affairs Department",
    href: ETHNIC_SUPPORT_URL,
  },
  {
    label:
      "List of Services for Ethnic Minorities provided by the Hong Kong Council of Social Service (as of September 2020)",
    href: ETHNIC_SERVICES_URL,
  },
];

const resourceSourcesZh = [
  {
    label: "由社會福利署提供的實物援助資料（截至 2024 年 8 月）",
    href: RESOURCE_MAP_URL,
  },
  {
    label: "由社會福利署提供的臨時收容中心 / 宿舍 / 短期宿舍名單（截至 2023 年 11 月）",
    href: TEMP_SHELTER_URL,
  },
  {
    label: "由民政事務總署種族關係組提供的少數族裔人士支援服務中心名單",
    href: ETHNIC_SUPPORT_URL,
  },
  {
    label: "由香港社會服務聯會提供的少數族裔服務名單（截至 2020 年 9 月）",
    href: ETHNIC_SERVICES_URL,
  },
];

class Contact extends React.Component {
  renderResourceSources(items, linkLabel) {
    return (
      <ul className="contact-page__source-list">
        {items.map((item) => (
          <li className="contact-page__source-item" key={item.label}>
            <span>{item.label}</span>
            <a href={item.href} target="_blank" rel="noopener noreferrer">
              {linkLabel}
            </a>
          </li>
        ))}
      </ul>
    );
  }

  renderEnglishPage() {
    return (
      <div className="contact-page contact-page--en">
        <div className="contact-page__shell">
          <section className="contact-page__hero">
            <p className="contact-page__eyebrow">Contact</p>
            <h1>Contact Us</h1>
            <p className="contact-page__lede">
              Jennifer Wu developed this Resource Map in collaboration with{" "}
              <a href="https://thinkcol.com/" target="_blank" rel="noopener noreferrer">
                Thinkcol
              </a>
              , a Hong Kong-based AI and data science consultancy firm.
            </p>
            <p className="contact-page__lede">
              If you would like to contact us, email{" "}
              <a href={EMAIL_LINK}>{EMAIL}</a>.
            </p>
          </section>

          <section className="contact-page__section">
            <div className="contact-page__section-heading">
              <p className="contact-page__eyebrow">Support</p>
              <h2>How Can You Help?</h2>
            </div>
            <div className="contact-page__help-grid">
              <article className="contact-page__card">
                <img
                  className="contact-page__icon"
                  src="./megaphone.png"
                  alt="Megaphone"
                />
                <h3>Share the map</h3>
                <p>Spread the word and share this resource map with others.</p>
              </article>

              <article className="contact-page__card">
                <img
                  className="contact-page__icon"
                  src="./emoji.png"
                  alt="Feedback"
                />
                <h3>Send feedback</h3>
                <p>
                  Send comments or suggestions to <a href={EMAIL_LINK}>{EMAIL}</a>.
                  We welcome ideas that help improve the Resource Map.
                </p>
              </article>

              <article className="contact-page__card">
                <img
                  className="contact-page__icon"
                  src="./clipboard.png"
                  alt="Contribute"
                />
                <h3>Add resources</h3>
                <p>
                  Join the community effort to build a more complete and accurate
                  database. If you would like to add resources, email{" "}
                  <a href={EMAIL_LINK}>{EMAIL}</a>.
                </p>
              </article>
            </div>
          </section>

          <section className="contact-page__section">
            <div className="contact-page__section-heading">
              <p className="contact-page__eyebrow">Sources</p>
              <h2>Data Sources</h2>
            </div>

            <div className="contact-page__sources">
              <article className="contact-page__source-card">
                <h3>Resource Map</h3>
                {this.renderResourceSources(resourceSourcesEn, "Link")}
                <p>
                  The original Social Welfare Department in-kind assistance data
                  is only available in Chinese and does not include fields such as
                  addresses or websites.
                </p>
                <p>
                  We expanded that dataset into bilingual resource-map content and
                  also added temporary accommodation / hostel information and
                  services relevant to ethnic minorities.
                </p>
              </article>

              <article className="contact-page__source-card">
                <h3>Service Map</h3>
                <p className="contact-page__service-source">
                  Service Map data:{" "}
                  <a
                    href={SERVICE_MAP_SOURCE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Social Welfare Department list of services
                  </a>
                  , updated April 2026.
                </p>
                <p>
                  This update applies to the Service Map only. Resource Map
                  sources above are maintained separately.
                </p>
                <p>
                  The Service Map is based on the SWD list of general social
                  service units.
                </p>
              </article>
            </div>
          </section>
        </div>
      </div>
    );
  }

  renderChinesePage() {
    return (
      <div className="contact-page contact-page--cn">
        <div className="contact-page__shell">
          <section className="contact-page__hero">
            <p className="contact-page__eyebrow">聯絡</p>
            <h1>聯絡我們</h1>
            <p className="contact-page__lede">
              此網站由 Jennifer Wu 與{" "}
              <a href="https://thinkcol.com/" target="_blank" rel="noopener noreferrer">
                Thinkcol
              </a>{" "}
              共同開發。
            </p>
            <p className="contact-page__lede">
              如欲聯絡我們，請電郵至 <a href={EMAIL_LINK}>{EMAIL}</a>。
            </p>
          </section>

          <section className="contact-page__section">
            <div className="contact-page__section-heading">
              <p className="contact-page__eyebrow">支持</p>
              <h2>你可以怎樣幫忙？</h2>
            </div>
            <div className="contact-page__help-grid">
              <article className="contact-page__card">
                <img
                  className="contact-page__icon"
                  src="./megaphone.png"
                  alt="分享"
                />
                <h3>分享資源地圖</h3>
                <p>歡迎向更多人介紹並分享這個資源地圖。</p>
              </article>

              <article className="contact-page__card">
                <img
                  className="contact-page__icon"
                  src="./emoji.png"
                  alt="意見"
                />
                <h3>提供意見</h3>
                <p>
                  如有任何建議或更新，歡迎電郵至 <a href={EMAIL_LINK}>{EMAIL}</a>，
                  幫助我們持續改善網站內容。
                </p>
              </article>

              <article className="contact-page__card">
                <img
                  className="contact-page__icon"
                  src="./clipboard.png"
                  alt="新增資料"
                />
                <h3>新增資源</h3>
                <p>
                  一起建立更完整、更準確的資料庫。如欲新增資源，請電郵至{" "}
                  <a href={EMAIL_LINK}>{EMAIL}</a>。
                </p>
              </article>
            </div>
          </section>

          <section className="contact-page__section">
            <div className="contact-page__section-heading">
              <p className="contact-page__eyebrow">資料來源</p>
              <h2>數據來源</h2>
            </div>

            <div className="contact-page__sources">
              <article className="contact-page__source-card">
                <h3>資源地圖</h3>
                {this.renderResourceSources(resourceSourcesZh, "連結")}
                <p>
                  社會福利署的原始實物援助資料目前主要為中文版本，亦未包含地址、
                  網站等欄位。
                </p>
                <p>
                  因此我們整理並擴充成中英雙語資料，同時加入臨時住宿 / 宿舍資訊及
                  適用於少數族裔的資源。
                </p>
              </article>

              <article className="contact-page__source-card">
                <h3>服務地圖</h3>
                <p className="contact-page__service-source">
                  服務地圖資料：{" "}
                  <a
                    href={SERVICE_MAP_SOURCE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    社會福利署服務名單
                  </a>
                  ，更新至 2026 年 4 月。
                </p>
                <p>此更新日期只適用於服務地圖，資源地圖資料來源則另行維護。</p>
                <p>服務地圖主要根據社會福利署的一般社會服務單位名單整理。</p>
              </article>
            </div>
          </section>
        </div>
      </div>
    );
  }

  render() {
    return getLanguage() === "en"
      ? this.renderEnglishPage()
      : this.renderChinesePage();
  }
}

export default translate(Contact);
